import React from "react";

import { Container, Row, Col } from "react-bootstrap";

function Footer() {
  return (
      <div className="text-center">
      <footer>
        <Container>
            <p/>
            Copyright &copy; Chaz
        </Container>
      </footer>
    </div>
  );
}

export default Footer;
